<template>
  <v-flex
    id="baseInfo"
    class="question"
  >
    <p><span class="sz_red--text">*</span> {{ $t('sheet.fields_required') }}</p>
    <p class="f-1">
      {{ $t('warehouses.base_data.hint_1') }}
      <a
        :href="warehouseTutorialLink"
        target="_blank"
      >
        {{ $t('warehouses.base_data.hint_link') }}
      </a>
      {{ $t('warehouses.base_data.hint_2') }}
    </p>
    <h2 class="header">
      {{ $t('warehouses.base_data.title') }}
    </h2>
    <ul class="questions-list">
      <li class="mt-4">
        <p class="header required">
          {{ question1.description }}
        </p>
        <v-checkbox
          v-for="(item, index) in question1.resources"
          :key="index"
          v-model="baseParameters"
          v-validate="validationRules.get('addWarehouseBaseParameters')"
          multiple
          :label="item.description"
          :value="item.id"
          :data-vv-as="' '"
          data-vv-name="baseParameters"
          required
          :disabled="readOnly"
        />
        <div
          v-if="errors.has('baseParameters')"
          class="v-message my-4 text-xs-center"
        >
          <div class="v-messages__message">
            {{ errors.first('baseParameters') }}
          </div>
        </div>
      </li>
      <li
        v-if="showOptionalQuestion"
        class="mt-4"
      >
        <p class="header required custom lA">
          {{ $t('warehouses.base_data.question_1a') }}
        </p>
        <v-textarea
          v-model="wayForWarehouseOperation"
          v-validate="validationRules.get('wayForWarehouseOperation')"
          :placeholder="$t('sheet.enter_text')"
          :error-messages="errors.collect('wayForWarehouseOperation')"
          :data-vv-as="' '"
          data-vv-name="wayForWarehouseOperation"
          required
          auto-grow
          :disabled="readOnly"
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';

import links from '@/constants/links';

const { mapFields } = createHelpers({
    getterType: 'warehouses/getBaseInfoField',
    mutationType: 'warehouses/updateBaseInfoField'
});

export default {
    name: 'BaseInfo',
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules,
            warehouseTutorialLink: links.WAREHOUSE_TUTORIAL
        };
    },
    computed: {
        ...mapFields(['baseParameters', 'showOptionalQuestion', 'wayForWarehouseOperation']),
        resource () {
            return this.$store.getters['warehouses/getResource'];
        },
        question1 () {
            return this.resource.find((el) => el.id === 1000);
        }
    },
    watch: {
        baseParameters: {
            handler (val) {
                this.showOptionalQuestion = val.length !== this.question1.resources.length;
            },
            immediate: true
        }
    }
};
</script>

<style scoped></style>
